var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowseIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 87,
    viewBox: "0 0 56 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7011_85)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9941 56.6928C25.3607 56.9044 26.3376 57.0391 27.3639 55.1851C27.8515 54.3041 28.2611 53.1007 28.5463 51.6204L21.4419 47.5187C21.7272 49.3284 22.1368 51.0047 22.6244 52.4487C23.6507 55.4879 24.6276 56.4812 24.9941 56.6928ZM21.0961 44.4698C20.9806 42.8231 20.9806 41.2342 21.0961 39.721L28.8921 44.222C29.0068 45.8682 29.0068 47.457 28.8921 48.9708L21.0961 44.4698ZM30.9814 53.0263C30.6244 55.1452 30.0364 56.8648 29.2826 58.0632C31.5273 58.1374 33.3347 57.0481 34.3822 54.9898L30.9814 53.0263ZM35.1615 52.5904L31.289 50.3546C31.3929 48.8341 31.3929 47.2463 31.289 45.6058L35.1599 47.8407C35.4177 49.5575 35.4177 51.1703 35.1599 52.5895L35.1615 52.5904ZM18.6977 43.085L14.8268 40.8502C14.569 39.1333 14.569 37.5206 14.8268 36.1014L18.6993 38.3372C18.5954 39.8577 18.5954 41.4455 18.6993 43.086L18.6977 43.085ZM15.6061 44.1494L19.0069 46.1128C19.3638 48.6439 19.9519 51.0425 20.7057 53.1113C18.461 50.5936 16.6536 47.4173 15.6061 44.1494ZM21.4419 37.0713L28.5463 41.1731C28.2611 39.3634 27.8515 37.6871 27.3639 36.243C26.3376 33.2039 25.3607 32.2106 24.9941 31.999C24.6276 31.7874 23.6507 31.6527 22.6244 33.5067C22.1368 34.3877 21.7272 35.591 21.4419 37.0713ZM30.9814 42.5789L34.3822 44.5424C33.3347 41.2745 31.5273 38.0982 29.2826 35.5805C30.0364 37.6492 30.6244 40.0478 30.9814 42.5789ZM20.7073 30.6295C19.9535 31.8279 19.3654 33.5475 19.0085 35.6664L15.6061 33.702C16.6536 31.6437 18.4626 30.5553 20.7073 30.6295ZM24.9941 29.1497C28.3754 31.1019 31.6181 34.5751 34.009 38.8053C36.4 43.0356 37.7431 47.6763 37.7431 51.7065C37.7431 55.7368 36.4 58.8265 34.009 60.296C31.6181 61.7654 28.3754 61.4942 24.9941 59.5421C21.6129 57.5899 18.3701 54.1167 15.9792 49.8864C13.5883 45.6562 12.2451 41.0155 12.2451 36.9852C12.2451 32.955 13.5883 29.8653 15.9792 28.3958C18.3701 26.9264 21.6129 27.1975 24.9941 29.1497Z",
    fill: "url(#paint0_linear_7011_85)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53906 2.91869L4.7366 1.04785C5.15431 0.801307 5.73045 0.837564 6.36421 1.20738L3.16658 3.07822C2.53282 2.7084 1.95676 2.67214 1.53906 2.91869Z",
    fill: "url(#paint1_linear_7011_85)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2376 84.3387L52.04 86.2095C52.4505 85.9702 52.7026 85.4554 52.7098 84.7302L55.9074 82.8594C55.9074 83.5845 55.6481 84.0994 55.2376 84.3387Z",
    fill: "url(#paint2_linear_7011_85)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7306 34.5525L55.9282 32.6816L55.8994 82.8609L52.709 84.7318L52.7306 34.5525Z",
    fill: "url(#paint3_linear_7011_85)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16797 3.0818L6.3656 1.21094L53.6452 28.6935L50.4548 30.5644L3.16797 3.0818Z",
    fill: "url(#paint4_linear_7011_85)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4531 30.572L53.6508 28.7012C54.9183 29.4336 55.9337 31.2174 55.9337 32.6822L52.7361 34.553C52.7361 33.0882 51.7206 31.3117 50.4531 30.572Z",
    fill: "url(#paint5_linear_7011_85)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4534 30.5744C51.7209 31.3068 52.7364 33.0906 52.7364 34.5554L52.7076 84.7346C52.7076 86.1994 51.6777 86.7868 50.4102 86.0544L3.13065 58.5646C1.86314 57.8322 0.847656 56.0483 0.847656 54.5836L0.876491 4.40428C0.876491 2.93951 1.9063 2.35215 3.17381 3.08453L50.4534 30.5744Z",
    fill: "url(#paint6_linear_7011_85)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7011_85",
    x1: 24.9941,
    y1: 29.1497,
    x2: 11.8339,
    y2: 51.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90ABDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7011_85",
    x1: -4.51037,
    y1: -6.45726,
    x2: 27.576,
    y2: 25.4168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7011_85",
    x1: 53.9701,
    y1: 93.6494,
    x2: 53.9701,
    y2: 71.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7011_85",
    x1: 54.315,
    y1: 114.02,
    x2: 54.315,
    y2: 41.9851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7011_85",
    x1: 0.848998,
    y1: -11.8632,
    x2: 32.9427,
    y2: 20.0111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7011_85",
    x1: 53.1898,
    y1: 57.4528,
    x2: 53.1898,
    y2: 35.5174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7011_85",
    x1: -19.4901,
    y1: -2.02766,
    x2: 53.1811,
    y2: 70.1468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7011_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.4426,
    height: 30.3924,
    fill: "white",
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 12.2451 21.7891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseIllustration);
export default __webpack_public_path__ + "static/media/browse-illustration.4626a9f3c71441b905b922e33799f11e.svg";
export { ForwardRef as ReactComponent };